import history from './../history';
import { version } from './../../package.json';
import Socket from './socket';
import { Encrypt, Decrypt } from './encrypt';

/* Configuração das variáveis */
export const MV_STORE = '_movingpay';

/* Configurações de autenticações */
export const isAuthenticated = () => {
	const situacao = Recuperar('token_acesso');
	return situacao;
};

/* FUNÇÕES PARA OTP */
export const isOTPVerified = () => {
	const otpStatus = Recuperar('otp_verificado');
	return otpStatus === true || otpStatus === 'true';
};

export const setOTPVerified = (verified) => {
	Atualizar('otp_verificado', verified);
};

export const clearOTPVerification = () => {
	Atualizar('otp_verificado', false);
};

export const setIsNeedRecaptcha = (value) => {
	Atualizar('need_recaptcha', value);
};

export const getIsNeedRecaptcha = () => {
	const need = Recuperar('need_recaptcha');
	return need
};

export const getMovingPayEmpresas = () => Recuperar('empresas');
export const getLembrarAcesso = () => Recuperar('lembrar_acesso');

/* Configurações de TOKEN */
export const getToken = () => Recuperar('token_acesso');
export const getTokenValid = () => Recuperar('validade_token');
export const setTokenValid = contador => Atualizar('validade_token', contador);

/* Configuração de permissões de acesso */
export const getMovingPayPermissoes = () => Recuperar('permissoes');
export const setMovingPayPermissoes = permissoes => Atualizar('permissoes', permissoes);

/* Configura a empresa ativa */
export const getEmpresaAtiva = () => Recuperar('empresa_ativa');
export const setEmpresaAtiva = empresa => Atualizar('empresa_ativa', empresa);

/* Configurações de versões */
export const setRemoteVersion = versao => Atualizar('versao_remota', versao.toString().trim());
export const getRemoteVersion = () => Recuperar('versao_remota');
export const getLocalVersion = () => version.toString().trim();

/* Recupera o id e nome do usuário */
export const getUserName = () => Recuperar('usuario_nome');
export const getUserId = () => Recuperar('usuario_id');
export const getProfileId = () => Recuperar('profile_id');
export const getLanguage = () => Recuperar('language');
export const getCurrency = () => RecuperarMoeda();
export const getRegistradora = () => RecuperarRegistradora();

/* Configurações de Login */
export const login = (response, lembrar_acesso) => {
	/* Prepara o objeto de encriptação */
	let o = Object.create(null);
	o.token_acesso = response.access_token;
	o.versao_remota = null;
	o.versao_local = version.toString().trim();
	o.alerta = 0;
	o.usuario_nome = response.user_name;
	o.usuario_id = response.user_id;
	o.profile_id = response.profile_id;
	o.lembrar_acesso = lembrar_acesso;
	o.validade_token = response.expires_at;
	o.empresa_ativa = response.empresas[0].id;
	o.empresas = response.empresas;
	o.language = response.language;
	o.permissoes = [];
	o.otp_verificado = false;

	/* Salva o objeto no Storage */
	localStorage.setItem(MV_STORE, Encrypt(JSON.stringify(o)));

	localStorage.removeItem('representante');
	localStorage.removeItem('empresa');

	/* Realiza a conexão do socket */
	if (!Socket) Socket.connect();
};

export const RecuperarRegistradora = () => {
	/* Recupera o objeto atual */
	let objeto = localStorage.getItem(MV_STORE) ? JSON.parse(Decrypt(localStorage.getItem(MV_STORE))) : null;

	/* Recupera a empresa ativa */
	let empresa = objeto ? objeto.empresas.find(item => item.id === objeto.empresa_ativa) : '';

	/* Retorna o endereço da logo atual */
	return empresa.registradora;
};

export const RecuperarMoeda = () => {
	/* Recupera o objeto atual */
	let objeto = localStorage.getItem(MV_STORE) ? JSON.parse(Decrypt(localStorage.getItem(MV_STORE))) : null;

	/* Recupera a empresa ativa */
	let empresa = objeto ? objeto.empresas.find(item => item.id === objeto.empresa_ativa) : '';

	/* Retorna o endereço da logo atual */
	return empresa.moeda;
};

/* Recupera a logo a ser exibida */
export const RecuperarLogo = () => {
	/* Recupera o objeto atual */
	let objeto = localStorage.getItem(MV_STORE) ? JSON.parse(Decrypt(localStorage.getItem(MV_STORE))) : null;

	/* Recupera a empresa ativa */
	let empresa = objeto ? objeto.empresas.find(item => item.id === objeto.empresa_ativa) : '';

	/* Retorna o endereço da logo atual */
	return empresa.logo_console;
};

/* Recupera a logo a ser exibida */
export const RecuperarNomeEmpresa = () => {
	/* Recupera o objeto atual */
	let objeto = localStorage.getItem(MV_STORE) ? JSON.parse(Decrypt(localStorage.getItem(MV_STORE))) : null;

	/* Recupera a empresa ativa */
	let empresa = objeto ? objeto.empresas.find(item => item.id === objeto.empresa_ativa) : '';

	const get_nome = empresa && empresa.nome.split('] ') && empresa.nome.split('] ').length > 1 ? empresa.nome.split('] ')[1] : empresa && empresa.nome.split('] ') && empresa.nome.split('] ').length === 1 ? empresa.nome.split('] ')[0] : '';

	/* Retorna o endereço da logo atual */
	return get_nome;
};

export const RecuperarAmbiente = () => {
	/* Recupera o objeto atual */
	let objeto = localStorage.getItem(MV_STORE) ? JSON.parse(Decrypt(localStorage.getItem(MV_STORE))) : null;

	/* Recupera a empresa ativa */
	let empresa = objeto ? objeto.empresas.find(item => item.id === objeto.empresa_ativa) : '';

	/* Verifica se o a empresa está em um ambiente de homologação */
	const ambiente = empresa && empresa.nome && empresa.nome.toLowerCase().includes('hml') ? 'hml' : '';

	return ambiente && ambiente === 'hml' && process.env.REACT_APP_ENV === 'development' ? 'development' : ambiente && ambiente === 'hml' && process.env.REACT_APP_ENV !== 'development' ? 'hml' : process.env.REACT_APP_ENV;
};

/* Recupera um acesso */
function Recuperar(chave) {
	/* Decripta o objeto */
	let objeto = localStorage.getItem(MV_STORE) ? JSON.parse(Decrypt(localStorage.getItem(MV_STORE))) : null;

	if (objeto) {
		return objeto[chave];
	} else {
		return null;
	}
}

/* Atualiza a logo */
export const StorageAtualizarLogo = nova_logo => {
	/* Verifica se o objeto existe */
	let objeto_encrypt = localStorage.getItem(MV_STORE);
	if (!objeto_encrypt) return 0;

	/* Decripta o objeto */
	let objeto = JSON.parse(Decrypt(objeto_encrypt));

	/* Salva o array de empresas dentro de um objeto */
	let array_empresas = objeto.empresas;

	/* Recupera a empresa ativa */
	let empresa = array_empresas.find(item => item.id === objeto.empresa_ativa);

	/* Novo array */
	let novo_array = array_empresas.filter(item => item.id !== objeto.empresa_ativa);

	/* Cria o novo objeto */
	let acrescenta = {
		id: empresa.id,
		nome: empresa.nome,
		logo_console: nova_logo
	};

	novo_array.push(acrescenta);

	objeto.empresas = novo_array;

	localStorage.setItem(MV_STORE, Encrypt(JSON.stringify(objeto)));
	window.dispatchEvent(new Event('storage'));

	return 0;
};

/* Atualizar o objeto principal */
function Atualizar(chave, valor) {
	/* Verifica se o objeto existe */
	let objeto = localStorage.getItem(MV_STORE);
	if (!objeto) return 0;

	/* Decripta o objeto */
	let objeto_decript = JSON.parse(Decrypt(objeto));

	/* Atualiza a chave solicitada */
	objeto_decript[chave] = valor;

	/* Salva novamente o objeto encriptado */
	localStorage.setItem(MV_STORE, Encrypt(JSON.stringify(objeto_decript)));

	return 0;
}

/* Configurações de logout */
export const logout = () => {
	/* Remove a permissão */
	// localStorage.removeItem(MV_STORE);

	/* Remove a permissão */
	Promise.allSettled([
		Atualizar('token_acesso', ''),
		Atualizar('versao_remota', ''),
		Atualizar('versao_local', ''),
		Atualizar('alerta', ''),
		Atualizar('usuario_nome', ''),
		Atualizar('usuario_id', ''),
		Atualizar('lembrar_acesso', ''),
		Atualizar('language', ''),
		Atualizar('currency', ''),
		Atualizar('validade_token', []),
		Atualizar('permissoes', []),
		Atualizar('otp_verificado', false),
		Atualizar('need_recaptcha', "0")
	]);

	/* Redireciona o usuário */
	history.push('/login', { mensagem: 'Seu acesso expirou. Efetue o login para continuar.' });
};
